if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host","remotes":[{"alias":"lk","name":"lk","entry":"https://lk-mf.web-api.dom.ru/_next/static/chunks/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(377|6662)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}